import { createUrl, request } from 'app/utils';
import { DipPage, Loading, NotFound, Page, Typography } from 'components';
import { useAuth } from 'features/auth';
import { useSchool } from 'features/school';
import { SurveyRequestBase } from 'features/surveys';
import { SurveyForm } from 'features/surveys/components';
import React, { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useParams, useSearchParams } from 'react-router-dom';

const SurveyView = () => {
  const { surveyUuid } = useParams();

  const [searchParams] = useSearchParams();
  const backLink = searchParams.get('backTo') || createUrl('dashboard');

  const { apiGatewayUrl } = useSchool();
  const { fullName, loginEmail } = useAuth();

  const {
    data: surveyData,
    isLoading,
    isError,
  } = useQuery(
    `survey-${surveyUuid}`,
    async () => {
      const response = await request<SurveyRequestBase>({
        url: `/api/v1/School/Surveys/${surveyUuid}`,
        baseURL: apiGatewayUrl,
        method: 'GET',
      });

      return response.data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const onComplete = useCallback(
    async (formData: string) => {
      await new Promise(async (resolve, reject) => {
        await request({
          url: `/api/v1/School/AssessSurveyResponse`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          data: {
            surveyUuid,
            formData,
          },
        })
          .then(resolve)
          .catch(reject);
      });
    },
    [surveyUuid, fullName, loginEmail]
  );

  if (isError) return <NotFound />;

  if (!surveyData || isLoading) return <Loading label="Por favor, aguarde." />;

  return (
    <Page title={`Pesquisa: ${surveyData?.name}`}>
      <DipPage
        id="surveysPreviewDipPage"
        centerContent={
          <Typography type="type3" fontWeight="bold">
            {surveyData?.name}
          </Typography>
        }
        backLink={backLink}
      >
        <SurveyForm formData={`${surveyData?.formData}`} onComplete={onComplete} />
      </DipPage>
    </Page>
  );
};

export default SurveyView;
